"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlan = exports.isCloudPlan = exports.plans = exports.planLabels = exports.cloudConfigPlans = void 0;
// used on organization.cloudConfig.plan
exports.cloudConfigPlans = [
    "Hobby",
    "Core",
    "Pro",
    "Team",
    "Enterprise",
];
exports.planLabels = {
    oss: "OSS",
    "cloud:hobby": "Hobby",
    "cloud:core": "Core",
    "cloud:pro": "Pro",
    "cloud:team": "Team",
    "cloud:enterprise": "Enterprise",
};
exports.plans = Object.keys(exports.planLabels);
// These functions are kept here to ensure consistency when updating plan names in the future.
const isCloudPlan = (plan) => plan?.startsWith("cloud");
exports.isCloudPlan = isCloudPlan;
const isPlan = (value) => exports.plans.includes(value);
exports.isPlan = isPlan;
